import MsgCampaign from 'src/modules/concession/messaging/campaign/Campaign.vue'

import { GlobalController } from 'src/shared/global/GlobalController'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  {
    path: 'campaign',
    name: 'MsgCampaign',
    component: MsgCampaign,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
